import {
  backendAnimation,
  // dsaAnimation,
  frontendAnimation,
  interviewAnimation
} from '../assets/animations/curriculum_page'
import backendRoadmapImage from '../assets/images/roadmaps/backend_roadmap.svg'
// import dsaRoadmapImage from '../assets/images/roadmaps/dsa_roadmap.svg'
import frontendRoadmapImage from '../assets/images/roadmaps/frontend_roadmap.svg'
import interviewprepRoadmapImage from '../assets/images/roadmaps/interview_roadmap.svg'

export const curriculum_info = [
  // {
  //   title: 'DS and Algorithms',
  //   description:
  //     'Dive into the world of coding, algorithms and problem solving.',
  //   expandImage: dsaRoadmapImage.src,
  //   animationProp: dsaAnimation,
  //   show: true
  // },
  {
    title: 'WebDev: Frontend',
    description:
      'An efficient application is never complete without designing an awesome UI/UX',
    expandImage: frontendRoadmapImage.src,
    animationProp: frontendAnimation,
    show: true
  },
  {
    title: 'WebDev: Backend',
    description:
      'A secure and efficient backend makes an app scalable to millions of users.',
    expandImage: backendRoadmapImage.src,
    animationProp: backendAnimation,
    show: true
  },
  {
    title: 'Interview Prep',
    description:
      'Making sure you are as great at delivering what you know as you are on the paper.',
    expandImage: interviewprepRoadmapImage.src,
    animationProp: interviewAnimation,
    show: true
  }
]
